import * as React from 'react';

export default function Body({content}) {
  if (!content) return null;

  return (
    <div className='accordion-item__body'>
      <p>{content}</p>
    </div>
  );
}
